import { useEffect } from 'react';
import { useWebLogin } from '../context';
export default function useWebLoginEvent(eventType, callback) {
    const { eventEmitter } = useWebLogin();
    useEffect(() => {
        eventEmitter.addListener(eventType, callback);
        return () => {
            eventEmitter.removeListener(eventType, callback);
        };
    }, [callback, eventEmitter, eventType]);
}
